
import { hydrateCSRTemplate } from "@fiverr-private/layout_lib/CSRTemplate";

import SessionMessages from '/home/circleci/app/packages/layout-session-messages-component/src/entries/SessionMessages';

const element = typeof document !== 'undefined' && document.querySelector('#SessionMessages');
if (element) {
    const props = window.initialData['SessionMessages'];

    hydrateCSRTemplate(SessionMessages, props, element, 'SessionMessages', 'SessionMessages');
}
export default SessionMessages;
